type Page = {
  page: number
  page_total: number
  size: number
  total: number
}

export const ExaminationState = {
  // registered: '未支付', // 已报名
  registered: '待评测', // 已报名
  paid: '待评测', // 已支付
  examining: '评测中',
  examined: '已完成', // 已评测
  closed: '已取消', // '退款、取消',
  failed: '未通过', // '考试未通过',
}

export type RegistrationPostReq = {
  // 评测报名
  broker_id: string
  applicant_id: string
  applicant_name: string
  identification_type: string
  identification_num: string
  birthday: string
  applicant_photo: string
  applying_for_grade: number
}

export type RegistrationGetReq = {
  // 查询评测报名
  broker_id?: string // N 申请代理人id
  applicant_id?: string // N 评测申请人id
  page: number
  size: number
}

export interface Registration extends RegistrationPostReq {
  // 评测报名信息
  id: number
  registration_num: string // 准考证号
  order_code?: string // 订单号
  examination_state: 'registered' | 'paid' | 'examining' | 'examined' | 'closed' | 'failed' // ExaminationState
  created_time: string
  updated_time: string
}

export type RegistrationListRes = Page & {
  registrations: Registration[]
}

export type CertificationGetReq = {
  applicant_id?: string // N	评测申请人id
  grade?: number // N	评测申请级别
  certification_num?: string // N	证书号码
}

export interface Certification {
  id: number
  certification_num: string // Y	证书号码
  name: string // Y	被认证人姓名
  identification_type: string // Y	被认证人证件类型
  identification_num: string // Y	被认证人证件号
  birthday: string // N 生日
  photo: string // Y	被认证人照片
  grade: number // Y	证书级别
  score: string // Y	认证成绩
  release_date: string // Y	发证日期
  certification_template: string // Y	证书模版
  certification_sign: string // Y	证书签名
}

export type CertificationListRes = Page & {
  certification: Certification[]
}

export type CheckReq = {
  // broker_id: string
  applicant_id: string
  // applying_for_grade: number
}

export type CheckRes = {
  result: boolean
  grade: number
}

export type GradeReq = {
  grade: number // 评测级别
}
export type GradeRes = {
  grade: number // Y	认证级别
  fen: string // Y	开局局面
  num_of_lesson: number // Y	最小课时要求
  fee: number // Y	费用
  duration?: number // N 评测时长要求
  err_limits?: number // N 最大行棋错误次数
  claim?: string // N 评测要求
  notice?: string // N	注意事项
  project_code: string // Y 商品编码
}
